import { ajax } from 'discourse/lib/ajax';
import DiscourseRoute from 'discourse/routes/discourse';

export default class ProxyviewsGlossaryRoute extends DiscourseRoute {
  async model() {
    const data = await ajax('/guides.json?category=glossary');
    const guides = (data.guides || []).map((g) => ({
      ...g,
      url: `/glossary/${g.slug}`,
      categoryLabel: g.category?.replace(/-/g, ' ')?.replace(/\b\w/g, (c) => c.toUpperCase()),
    }));
    return { guides };
  }

  titleToken() {
    return 'Proxy Glossary';
  }
}
